import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { Typography } from '@mui/material';
import { get } from 'lodash';
import { enumT } from '../../../../utils/helper';
import { DisplayDateTime } from '../../../../utils/formats';

import Schema from '../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
const P = Schema.attributes;

const ZuwendungsantragRightSidebar: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<RightSidebarPaper>
				<span>
					<Typography variant="subtitle2">Art des Antrags:</Typography>
					<Typography variant="body1">Zuwendungsantrag</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Antragsart:</Typography>
					<Typography variant="body1">
						{get(application, P.Allgemein_Antragsart.path)}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Status:</Typography>
					<Typography variant="body1">
						{enumT(get(application, P.Antragsstatus_Antragsstatus.path))}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Förderprogramm:</Typography>
					<Typography variant="body1">
						{get(application, P.Foerderprogramm.schema.attributes.Allgemein_Name.path)}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Eingangsnummer:</Typography>
					<Typography variant="body1">
						{get(application, P.Allgemein_Projektnummer.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Erstellt am:</Typography>
					<Typography variant="body1">
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Zuletzt geändert am:</Typography>
					<Typography variant="body1">
						{DisplayDateTime(get(application, 'attributes.updatedAt'))}
					</Typography>
				</span>
			</RightSidebarPaper>
		</>
	);
};
export default ZuwendungsantragRightSidebar;
